import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import WhatsAppButton from "./components/WhatsAppButton";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Trips from "./pages/Trips";
import Contact from "./pages/Contact";
import "./styles/global.css";
import "./styles/navbar.css";
import "./styles/home.css";
import "./styles/services.css";
import "./styles/trips.css";
import "./styles/contact.css";
import "./styles/components.css";
import OfferPopup from "./components/OfferPopup";
import AdminOffer from "./pages/AdminOffer";


function App() {
  return (
    <BrowserRouter>

      <Navbar />
      <OfferPopup />
      <WhatsAppButton />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/trips" element={<Trips />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin-offer" element={<AdminOffer />} />
      </Routes>

    </BrowserRouter>
  );
}

export default App;